"use client";
import useSoftSetting from "@/hooks/useSoftSetting";
import Link from "next/link";
const footerSpan = `text-xs sm:text-sm text-ws-grayBlue-500`;
function SecondaryFooter() {
  const { data } = useSoftSetting();

  return (
    <div className="h-[50px] xxl:container xxl:mx-auto   flex md:flex-row md:gap-0 mt-auto  justify-between items-center px-6 lg:mb-4 mb-24 lg:px-16 py-4  flex-col gap-3">
      <span className={footerSpan}>
        تمام حقوق سایت برای {data?.bussinessTitle} محفوظ است.
      </span>
      <span className={footerSpan}>
        Developed by
        <Link
          className="underline underline-offset-[6px]	pl-2"
          href="https://jadoosoft.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          jadoosoft.com
        </Link>
      </span>
    </div>
  );
}

export default SecondaryFooter;
